<template>
    <modal :modal-id="modalId"
                     :title="modalTitle"
                     :preloader="preloader"
                     class="message-modal"
                     @submit="submit"
                     @close-modal="closeModal">
        <template slot="body">
            <app-overlay-loader v-if="preloader"/>

            <div class="box">
                <div class="col-sm-12 col-md-10 pl-0 float-left mb-5">
                    <h2 v-if="this.tableId == 'careers'" class="mb-2">{{ $t('with_advert') }} {{ inputs.job }}</h2>
                    <h2 v-else-if="this.tableId == 'onboarding' && preloader" class="mb-2">{{ $t('with_info_about_employee') }}</h2>
                    <h2 v-else-if="this.tableId == 'onboarding'" class="mb-2">{{ $t('with_info_about_employee') }} {{ inputs.name }}</h2>
                    <h2 v-else-if="preloader" class="mb-2">{{ $t('with_info_about_candidate') }}</h2>
                    <h2 v-else class="mb-2">{{ $t('with_info_about_candidate') }} {{ inputs.name }}</h2>

                    <div class="row col-md-9 justify-content-between half-width-container pr-0 mt-3 mb-2">
                        <div class="form-group row align-items-center md-half-width">
                            <label for="inputs_subject" class="col-sm-12 mt-3 mb-0">
                                {{ $t('subject') }}
                            </label>
                            <app-input  id="inputs_subject"
                                        class="col-sm-12 pr-0"
                                        type="text"
                                        v-model="inputs.subject"
                                        :required="true"
                                        />
                        </div>
                        <div class="form-group row align-items-center md-half-width">
                            <label for="inputs_title" class="col-10 mt-3 mb-2 pl-0">
                                {{ $t('choose_from_template') }}
                            </label>
                            <a href="/mail-templates" target="_blank" class="col-2 mt-1 text-right text-muted" :title="$t('edit_templates')">
                                <app-icon :name="'edit'" width="18" height="18"/>
                            </a>

                            <app-input id="inputs_template"
                                    class="pr-0 w-100 pr-md-2"
                                    type="select"
                                    v-model="template"
                                    :list="templateOptions"/>
                        </div>
                    </div>


                    <form class="mb-5"
                        :class="{'loading-opacity': preloader}"
                        ref="form">

                        <div class="form-group row align-items-center">
                            <label for="inputs_message" class="col-sm-12 mb-2">
                                {{ $t('message') }}
                            </label>
                            <app-overlay-loader v-if="editorPreloader"/>
                            <app-input v-if="finishedGetData" id="inputs_message"
                                    class="col-sm-9"
                                    type="text-editor"
                                    v-model="inputs.message"
                                    :placeholder="$t('text_type_input')"
                                    />
                        <app-input v-if="editorPreloader"
                                                id="inputs_text_blind"
                                                class="col-sm-12"
                                                :class="{'loading-opacity': editorPreloader}"
                                                type="textarea"/>
                        </div>
                    </form>
                </div>
                <div class="col-sm-12 col-md-2 mt-5 float-left text-center p-0">
                    <img src="/images/illustration_send.svg" style="width: 100%;min-width: 200px;">
                </div>
            </div>




            <div class="clearfix"></div>

        </template>
    </modal>
</template>

<script>
    import {FormMixin} from '../../../../../../core/mixins/form/FormMixin.js';
    import {ModalMixin} from "../../../../../Mixins/ModalMixin";
    import {UserMixin} from "../../../../../../app/Components/Views/Auth/Mixins/UserMixin";
    import AppLibrary from "../../../../../Helpers/AppLibrary";

    export default {
        name: "MessageModal",
        extends: AppLibrary,
        mixins: [FormMixin, ModalMixin, UserMixin],
        props: {
            tableId: String,
            selectedRows: Array,
            timelineStates: Array,
            jobOptions: Array,
            modalType: String,
        },
        watch: {
          template: {
            sync: true,
            handler (val, oldVal) {
                console.log('watch');
                if(val != 0){
                    this.getTemplateData();
                }
            }
          }
        },
        data() {
            return {
                preloader: false,
                editorPreloader: false,
                finishedGetData: false,
                template: 0,
                templateOptions: [
                    {id: 0, value: this.$t('select'),},
                ],

                inputs: {
                    event_type: 'notification',
                    event_date: '',
                    mailto: '',
                    replyto: '',
                    additionalmailto: '',
                    subject: '',
                    name: '',
                    job: '',
                    status: '2',
                },
                modalId: 'message-Modal',
                modalTitle: this.$t('add'),
                candidatesIds: {},
                candidatesJobs: {},
                candidatesNames: {},
                messageHeader: '',

                value: {},
                tagPreloader: false,
                multiCreatePreloader: false,
            }
        },
        created() {
            if (this.selectedCandidates) {
                this.preloader = true;
            }

            // Display available mail templates
            let url = 'admin/app/templates?filter_with_status_id=1&per_page=500';
            this.axiosGet(url).then(response => {

                const templateOptionsArray = response.data.data.map(({
                  name: value,
                  ...rest
                }) => ({
                  value,
                  ...rest
                }));

                this.templateOptions = templateOptionsArray;
                this.templateOptions.unshift({"id": 0, "value": this.$t('select')});

            }).catch(({response}) => {
            }).finally(() => {

                this.finishedGetData = true;

            });

        },
        mounted() {

            let candidateDetails = this.selectedRows.map(candidateDetails => {
                return candidateDetails.fullname;
            });
            this.inputs.name = Object.values(candidateDetails).join(", ");
            this.candidatesNames = candidateDetails;

            candidateDetails = this.selectedRows.map(candidateDetails => {
                return candidateDetails.email;
            });
            this.inputs.mailto = Object.values(candidateDetails).join(", ");

            candidateDetails = this.selectedRows.map(candidateDetails => {
                return candidateDetails.job;
            });
            this.inputs.job = Object.values(candidateDetails).join(",");
            this.candidatesJobs = candidateDetails;

            candidateDetails = this.selectedRows.map(candidateDetails => {
                return candidateDetails.id;
            });
            this.inputs.candidate_id = Object.values(candidateDetails).join(",");
            this.inputs.id = Object.values(candidateDetails).join(",");
            this.candidatesIds = candidateDetails;

            candidateDetails = this.selectedRows.map(candidateDetails => {
                return candidateDetails.timeline_state;
            });
            this.inputs.timeline_state = Object.values(candidateDetails).join(",");

            candidateDetails = this.selectedRows.map(candidateDetails => {
                return candidateDetails.status;
            });
            let candidateStatus = Object.values(candidateDetails).join(",");

            if(candidateStatus[0] == 1){
                this.inputs.status = 'talentpool';
            } else if (candidateStatus[0] == 2){
                this.inputs.status = 'hiring';
            } else {
                this.inputs.status = 'onboarding';
            }

            let photo = '';
            if(this.user.loggedInUser.img){
                photo = '<td style="width: 100px"><img src="'+window.location.origin+this.user.loggedInUser.img+'" alt="User profile photo" height="60"></td>';
            }
            let messageSuffix = 'S pozdravem <br><table align="left"><tbody><tr>'+photo+'<td><b>'+this.user.loggedInUser.full_name+'</b><br>'+this.user.loggedInUser.roles[0].name+'<br>'+this.user.loggedInUser.email+'</td></tr></tbody></table><br><br><br>';

            if(this.tableId == 'careers'){
                this.inputs.message = this.messageHeader+'Doplňte text zprávy...<br><br>'+messageSuffix;
            } else if (this.tableId == 'onboarding'){
                this.inputs.message = this.messageHeader+'Doplňte text zprávy...<br><br>'+messageSuffix;
            } else {
                this.inputs.message = this.messageHeader+'Doplňte text zprávy...<br><br>'+messageSuffix;
            }

            this.inputs.replyto = this.user.loggedInUser.email;

        },
        methods: {
            beforeSubmit() {
                this.preloader = true;
            },
            submit() {
                this.prepareNotification();

            },
            getMessageHeader() {
                let message = '';
                if(this.tableId == 'careers'){
                    message = "<b>"+this.$t('i_am_sending_a_link_advert')+"</b><br>";
                } else if (this.tableId == 'onboarding'){
                    message = "<b>"+this.$t('i_am_sending_a_link_to_employee')+"</b><br>";
                } else {
                    message = "<b>"+this.$t('i_am_sending_a_link_to_candidate')+"</b><br>";
                }
                message += "<ul>";
                let _this = this;
                let jobs = '';
                let selectedJobId = '';

                let candidateDetailIds = this.selectedRows.map(candidateDetails => {
                    return candidateDetails.id;
                });
                candidateDetailIds.forEach(function (candidateId, i) {
                    jobs = _this.jobOptions;
                    selectedJobId = jobs.find(o => o.id === _this.candidatesJobs[i]);
                    let statusUrl = '';
                    if(_this.inputs.status == 1){
                        statusUrl = 'talentpool';
                    } else if(_this.inputs.status == 2){
                        statusUrl = 'hiring';
                    } else if(_this.inputs.status == 3){
                        statusUrl = 'onboarding';
                    }
                    var getUrl = window.location;
                    var baseUrl = getUrl .protocol + "//" + getUrl.host + "/";

                    message += '<li><b><a href="'+baseUrl+statusUrl+'?profile='+candidateId+'&job='+_this.candidatesJobs[i]+'">'+_this.candidatesNames[i]+', '+selectedJobId.value+'</a></b></li>';
                });
                this.messageHeader = message+"</ul><hr>";
            },
            prepareNotification() {
                this.preloader = true;

                this.inputs.email = 'podpora@onboardio.pro';
                this.inputs.status = 2;

                let mailTos = this.inputs.mailto.split(',');
                let ids = this.inputs.id.split(',');
                let names = this.inputs.name.split(',');
                let jobs = this.inputs.job.split(',');

                console.log('odesílám email '+this.inputs.mailto);
                this.sendMailNotifications();


                // Always send separate app notifications (because we need to store each entry for a candidate in his history)
                // Rejection, Notification
                let i = 0;
                let _this = this;

                for (let i = 0; i < ids.length; i++) {
                     setTimeout(function timer() {
                         _this.inputs.job = jobs[i];
                         _this.inputs.id = ids[i];
                         _this.inputs.name = names[i];
                         _this.sendAppNotifications();
                         console.log('odesílám app notifikaci s '+_this.inputs.name);
                     }, i * 50);
                }



            },
            sendAppNotifications() {
                // Push predefined automatic in-app notification and/or e-mail
                this.axiosPatch({
                    url: 'admin/app/candidates-app-notifications',
                    data: this.inputs
                }).then(response => {

                }).finally(() => {

                });
            },
            sendMailNotifications() {
                // Send personalized e-mail to unique set of receipents
                this.axiosPatch({
                    url: 'admin/app/candidates-mail-notifications',
                    data: this.inputs
                }).then(response => {

                    if (response.data) {
                        this.afterSuccess(response);
                    } else {
                        this.afterError(response);
                    }

                }).finally(() => {
                    this.preloader = false;
                    $(".floating-bar-fixed-bottom").addClass("animate__fadeOut").delay(100).fadeOut();
                    setTimeout(function(){ $("#message-Modal").modal('hide'); }, 10);
                    this.$hub.$emit('reload-' + this.tableId);
                });
            },
            afterSuccessFromGetEditData(response) {

                this.preloader = false;

            },
            afterSuccess(response) {
                this.$toastr.s(this.$t(response.data));

            },
            afterError(response) {
                this.$toastr.s(this.$t(response.data));

            },
            clear() {
                this.inputs = {};
            },

            /**
             * Fill from Template
             */
            getTemplateData() {
                let photo = '';
                if(this.user.loggedInUser.img){
                    photo = '<td style="width: 100px"><img src="'+this.user.loggedInUser.img+'" alt="User profile photo" height="60"></td>';
                }
                let messageSuffix = '<table align="left"><tbody><tr>'+photo+'<td><b>'+this.user.loggedInUser.full_name+'</b><br>'+this.user.loggedInUser.roles[0].name+'<br>'+this.user.loggedInUser.email+'</td></tr></tbody></table><br><br><br>';

                let selectedTemplateId = parseInt(this.template);
                let templates = this.templateOptions;
                const selectedTemplate = templates.find(o => o.id === selectedTemplateId);

                this.finishedGetData = false;
                this.editorPreloader = true;
                this.inputs.title = selectedTemplate.title;
                this.inputs.message = this.messageHeader+selectedTemplate.body+messageSuffix;

                let _this = this;
                setTimeout(function(){
                    _this.finishedGetData = true;
                    _this.editorPreloader = false;
                }, 500);
            },



        },
    }
</script>
